"use strict";
// Cards.ts
//
// Helpers for mapping Ranks and Suits to Strings and back to enums.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCardRankToShortString = getCardRankToShortString;
exports.getCardRankToString = getCardRankToString;
exports.getCardRankFromString = getCardRankFromString;
exports.getCardSuitToShortString = getCardSuitToShortString;
exports.getCardSuitToString = getCardSuitToString;
exports.getCardSuitFromString = getCardSuitFromString;
const Rank_1 = require("../enums/Rank");
const Suit_1 = require("../enums/Suit");
//
//   Ranks
//
const cardRankToString = new Map([
    [Rank_1.Rank.ACE, { short: "A", text: "Ace" }],
    [Rank_1.Rank.TWO, { short: "2", text: "Two" }],
    [Rank_1.Rank.THREE, { short: "3", text: "Three" }],
    [Rank_1.Rank.FOUR, { short: "4", text: "Four" }],
    [Rank_1.Rank.FIVE, { short: "5", text: "Five" }],
    [Rank_1.Rank.SIX, { short: "6", text: "Six" }],
    [Rank_1.Rank.SEVEN, { short: "7", text: "Seven" }],
    [Rank_1.Rank.EIGHT, { short: "8", text: "Eight" }],
    [Rank_1.Rank.NINE, { short: "9", text: "Nine" }],
    [Rank_1.Rank.TEN, { short: "10", text: "Ten" }],
    [Rank_1.Rank.JACK, { short: "J", text: "Jack" }],
    [Rank_1.Rank.QUEEN, { short: "Q", text: "Queen" }],
    [Rank_1.Rank.KING, { short: "K", text: "King" }],
    [Rank_1.Rank.HIGH_ACE, { short: "A", text: "Ace" }],
]);
function getCardRankToShortString(rank) {
    const rankString = cardRankToString.get(rank);
    if (rankString) {
        return rankString.short;
    }
    return "";
}
function getCardRankToString(rank) {
    const rankString = cardRankToString.get(rank);
    if (rankString) {
        return rankString.text;
    }
    return "";
}
function getCardRankFromString(rankString) {
    // needed only for our tests, every rank is a single letter and 10 as digit is 2 letters that's why
    // it is represented as T
    if (rankString === "T") {
        return Rank_1.Rank.TEN;
    }
    for (const [rank, text] of cardRankToString) {
        if (text.short === rankString || text.text === rankString) {
            return rank;
        }
    }
    return null;
}
//
//   Suits
//
const cardSuitToString = new Map([
    [Suit_1.Suit.CLUB, { short: "c", text: "Clubs" }],
    [Suit_1.Suit.DIAMOND, { short: "d", text: "Diamonds" }],
    [Suit_1.Suit.HEART, { short: "h", text: "Hearts" }],
    [Suit_1.Suit.SPADE, { short: "s", text: "Spades" }],
]);
function getCardSuitToShortString(suit) {
    const suitString = cardSuitToString.get(suit);
    if (suitString) {
        return suitString.short;
    }
    return "";
}
function getCardSuitToString(suit) {
    const suitString = cardSuitToString.get(suit);
    if (suitString) {
        return suitString.short;
    }
    return "";
}
function getCardSuitFromString(suitString) {
    for (const [suit, text] of cardSuitToString) {
        if (text.short === suitString || text.text === suitString) {
            return suit;
        }
    }
    return null;
}
//# sourceMappingURL=Cards.js.map